/**
 * @generated SignedSource<<68df8af430f90a62d6a9328adb7c531b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateSelectorCreateTemplatePopupMutation$variables = {
  name: string;
  todoWorkspaceId: string;
};
export type TemplateSelectorCreateTemplatePopupMutation$data = {
  readonly todoWorkspace: {
    readonly createTemplate: {
      readonly todoWorkspace: {
        readonly " $fragmentSpreads": FragmentRefs<"TemplateSelector_todo">;
      };
      readonly workspace: {
        readonly " $fragmentSpreads": FragmentRefs<"TemplateSelector_workspace">;
      } | null;
    } | null;
  };
};
export type TemplateSelectorCreateTemplatePopupMutation = {
  response: TemplateSelectorCreateTemplatePopupMutation$data;
  variables: TemplateSelectorCreateTemplatePopupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateSelectorCreateTemplatePopupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspaceTemplateCreateResult",
            "kind": "LinkedField",
            "name": "createTemplate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplateSelector_workspace"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoWorkspace",
                "kind": "LinkedField",
                "name": "todoWorkspace",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplateSelector_todo"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateSelectorCreateTemplatePopupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspaceTemplateCreateResult",
            "kind": "LinkedField",
            "name": "createTemplate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoWorkspaceTemplate",
                    "kind": "LinkedField",
                    "name": "templates",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoWorkspace",
                "kind": "LinkedField",
                "name": "todoWorkspace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "descriptionFiles",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "descriptionImages",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoWorkspaceTemplate",
                    "kind": "LinkedField",
                    "name": "template",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f9467116216367f57d1571007fa8e5fa",
    "id": null,
    "metadata": {},
    "name": "TemplateSelectorCreateTemplatePopupMutation",
    "operationKind": "mutation",
    "text": "mutation TemplateSelectorCreateTemplatePopupMutation(\n  $todoWorkspaceId: ID!\n  $name: String!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    createTemplate(name: $name) {\n      workspace {\n        ...TemplateSelector_workspace\n        id\n      }\n      todoWorkspace {\n        ...TemplateSelector_todo\n        id\n      }\n    }\n  }\n}\n\nfragment TemplateSelectorTemplateItem_TodoWorkspaceTemplate on TodoWorkspaceTemplate {\n  id\n  name\n}\n\nfragment TemplateSelector_todo on TodoWorkspace {\n  id\n  updatedBy {\n    __typename\n    id\n  }\n  body\n  title\n  descriptionFiles {\n    __typename\n    id\n  }\n  descriptionImages {\n    __typename\n    id\n  }\n  template {\n    id\n    name\n    ...TemplateSelectorTemplateItem_TodoWorkspaceTemplate\n  }\n}\n\nfragment TemplateSelector_workspace on Workspace {\n  id\n  templates {\n    id\n    ...TemplateSelectorTemplateItem_TodoWorkspaceTemplate\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8a4321ea2ee85f93480745ad9c5e402";

export default node;
